import styled from 'styled-components'

// Wrapper
export const TemplateForCustomWrapper = styled.div`
  /* Parent
  ------------------------------- */
  /* Childrens
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  &.is-modifier-name {}

  /* Media queries
  ------------------------------- */
`
